var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "116px",
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 26.000000)",
    fill: "#404040",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1033333,62.1566667 C55.1362657,63.191121 56.5381365,63.7723994 58,63.7723994 C59.4618635,63.7723994 60.8637343,63.191121 61.8966667,62.1566667 L114.233333,9.82 C115.810651,8.24500579 116.282901,5.87446244 115.429578,3.8152452 C114.576255,1.75602797 112.565687,0.414344915 110.336667,0.416663658 L102.076667,0.416663658 C100.615626,0.41514643 99.2138715,0.994314613 98.18,2.02666667 L60.065,40.1475 C59.5178085,40.6960766 58.7748257,41.0043804 58,41.0043804 C57.2251743,41.0043804 56.4821915,40.6960766 55.935,40.1475 L17.82,2.02666667 C16.7861285,0.994314613 15.3843736,0.41514643 13.9233333,0.416663658 L5.66333333,0.416663658 C3.43431318,0.414344915 1.42374533,1.75602797 0.570422058,3.8152452 C-0.282901212,5.87446244 0.189349497,8.24500579 1.76666667,9.82 L54.1033333,62.1566667 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.d3765dfc.svg";
export { ForwardRef as ReactComponent };